import {Component, ElementRef, Input, OnInit} from '@angular/core';

@Component({
    selector: 'cmn-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {
    @Input() labelWidth: string = '350px';
    @Input() labelText: string = '';
    @Input() valid: boolean = true;
    @Input() disabled: boolean = false;
    @Input() labelPosition: string = 'left';
    @Input() preview: boolean = false;
    @Input() fieldName: string = null;
    @Input() tooltip: string = null;

    constructor(public elemRef: ElementRef) {
    }

    ngOnInit() {
    }
}
